import { FC } from 'react';
import { useHomeContext } from '#home/hooks';
import { BackgroundImage } from '#home/components';

const BackgroundImageDynamic: FC = () => {
  const { mainImageUrl } = useHomeContext();

  if (!mainImageUrl) {
    return null;
  }

  return <BackgroundImage src={mainImageUrl} />;
};

export { BackgroundImageDynamic };
